import request from 'scripts/services/request';


const getWithAuth = (url) => request(url, { credentials: 'include' });

export default getWithAuth;
